import React, { useState, useEffect, useRef } from 'react';
import { FaTruck, FaBolt, FaChartLine, FaClock } from 'react-icons/fa';

const DashcamFilters = ({ zones, selectedZoneIndex, setSelectedZoneIndex, vehicleTypes, selectedVehicleTypes, toggleVehicleType, metrics, isOpen = true }) => {
  const [isVisible, setIsVisible] = useState(isOpen);
  const [height, setHeight] = useState(isOpen ? 'auto' : 0);
  const contentRef = useRef(null);

  useEffect(() => {
    setIsVisible(isOpen);
    if (isOpen) {
      setHeight(contentRef.current?.scrollHeight || 'auto');
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <div
      className={`overflow-hidden transition-all duration-300 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}
      style={{ height }}
    >
      <div ref={contentRef} className="mb-6 space-y-6 shadow-lg p-4 rounded-lg bg-green-100 bg-opacity-30">
        {/* Zones */}
        {/* <div className="flex space-x-4 overflow-x-auto pb-2">
          {zones.map((zone, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedZoneIndex(idx)}
              className={`px-4 py-2 rounded-lg text-sm font-medium cursor-pointer flex items-center gap-2 ${
                idx === selectedZoneIndex
                  ? 'bg-primary text-white shadow'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              {idx === selectedZoneIndex && (
                <span className="w-1.5 h-1.5 bg-white rounded-full"></span>
              )}
              {zone.name}{' '}
              <span
                className={`ml-auto px-2 py-0.5 text-xs rounded-full ${
                  idx === selectedZoneIndex
                    ? 'bg-white text-primary'
                    : 'bg-green-100 text-green-700'
                }`}
              >
                {zone.activeCount}
              </span>
            </div>
          ))}
        </div> */}

        {/* Metrics */}
        <div className="flex gap-4 overflow-x-auto pb-2">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-white rounded-xl p-4 shadow-sm flex flex-col gap-2 flex-1 min-w-[150px]">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center">{metric.icon}</div>
                <div className="text-2xl font-bold text-gray-800">{metric.value}</div>
              </div>
              <div className="text-xs text-gray-500 mt-1">{metric.label}</div>
              <div className="w-full mt-2 bg-gray-100 rounded-full h-1">
                <div className="h-1 bg-blue-500 rounded-full" style={{ width: `${Math.min(metric.progress, 1) * 100}%` }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashcamFilters;